import React from 'react';
import PaymentListContainer from '../../containers/paymentmng/PaymentListContainer';

const PaymentListPage = () => {
  return <PaymentListContainer />
};

export default PaymentListPage;
